import './style.scss'
import { useContext, useEffect, useState } from 'react'
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { CustomContainer, FormGroupWithIcon, FlexRow, AppSpan, AppText, Button, Form, FormGroup } from 'src/style'
import { billingConfigurationsColumns, billingConfigurationsData } from 'src/utils/table-layout'
import { FiChevronDown } from 'react-icons/fi'
import { ServerSideTable } from 'src/component'
import helpers from 'src/utils/helpers'
import { CreateInstitutionBillingConfig } from 'src/popup'
import { InstitutionBillingConfigData, ProductBillingConfig } from 'src/model'

export const BillingConfiguration: React.FC<any> = ({product}) => {
    const { API } = useContext(ApiContext)
    const [selectedBillingType, setSelectedBillingType] = useState('General')
    const [institutionBillingConfigsInfo, setinstitutionBillingConfigsInfo] = useState<any>(null)
    const [institutionBillingConfigs, setinstitutionBillingConfigs] = useState<Array<InstitutionBillingConfigData>>([])
    const [productBillingConfig, setProductBillingConfig] = useState<ProductBillingConfig|null>(null)
    const [input, setInput] = useState({
        monthlyFee: '', activeUsersFee: '', 
        totalUsersFee: '', activeBackendUsersFee: '', 
        totalBackendUsersFee: ''
    })
    const [selectedBillingConfig, setSelectedBillingConfig] = useState<InstitutionBillingConfigData|null>(null)
    const [view, setView] = useState('')

    const billingConfigTypes = ['General', 'Institution Specific']

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => setInput({...input, [e.target.name]: e.target.value})

    useEffect(() => {
        if (selectedBillingType === 'General')  handleFetchProductBillingConfig()
        else handleFetchInstitutionBillingConfigs()
    }, [selectedBillingType])

    async function handleFetchInstitutionBillingConfigs (pageNumber = 1, pageSize = 10) {
        const response = await API.getInstitutionBillingConfig({
            pageNumber, pageSize, 
            sortColumn: 'id', 
            sortOrder: 'desc',
            filter: {
                productId: product.id
            }
        })

        // const response = { data: billingConfigurationsData, totalRecord: 4}

        if (response) {
            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setinstitutionBillingConfigsInfo(response)
            setinstitutionBillingConfigs(response.data)
        }
    }

    async function handleFetchProductBillingConfig () {
        const response = await API.getProductBillingConfig(product.id)
        const { activeUsersFee, totalUsersFee, activeBackendUsersFee, totalBackendUsersFee, monthlyFee } = response
        
        setProductBillingConfig(response)
        
        if (response) setInput({
            ...input,
            monthlyFee: monthlyFee,
            activeUsersFee, totalUsersFee,
            activeBackendUsersFee, totalBackendUsersFee
        })
    }

    async function handleBillingConfigAction (config: InstitutionBillingConfigData, actionType: string) {
        if (actionType === 'delete') {
            const response = await API.deleteInstitutionProductBillingConfig(config.id)
            if (response) handleFetchInstitutionBillingConfigs()
        }
        else {
            setSelectedBillingConfig(config)
            setView('edit-config')
        }
    }

    async function handleCreateInstitutionBillingConfig () {
        setSelectedBillingConfig(null)
        setView('create-config')
    }

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()  

        const payload = {
            ...input,
            productId: product.id
        }
        
        if (productBillingConfig?.id) API.updateProductBillingConfig(productBillingConfig.id, payload)
        else API.createProductBillingConfig(payload)
    }

    return (
        <>
            <CustomContainer
                className="billing-config-options-dropdown"
                bottomMargin="2"
            >
                <FormGroupWithIcon>
                    <label>Configiuration Type</label>
                    <div className="input-with-icon" style={{height: '4rem'}}>
                        <select 
                            name='role'
                            value={selectedBillingType}
                            style={{color: selectedBillingType ? '#000000' : '#667085'}}
                            onChange={(e) => setSelectedBillingType(e.target.value)}
                            autoComplete="off"
                        >
                            {
                                billingConfigTypes?.map((item, index) => {
                                    return (
                                        <option value={item} key={index}>{item}</option>
                                    )
                                })
                            }
                        </select>
                        <FiChevronDown className="input-with-icon-tag" />
                    </div>
                </FormGroupWithIcon>
            </CustomContainer>
            <FlexRow
                //justifyContent="space-between" 
                alignItems="flex-start" 
                gap="3" topMargin="3"
            >
                <CustomContainer
                    width="21"
                    className="billing-config-options"
                >
                    {
                        billingConfigTypes?.map((item, index) => {
                            return (
                                <CustomContainer
                                    padding="1" radius="0.6"
                                    topPadding="0.8" bottomPadding="0.8"
                                    bgColor={selectedBillingType === item ? '#E7F6F5' : 'transparent'}
                                    key={index}
                                    onClick={() => setSelectedBillingType(item)}
                                >
                                    <AppSpan
                                        color={selectedBillingType === item ? '#0A756F' : '#667085'}
                                        fontWeight="500"
                                        cursor="pointer"
                                    >
                                        {item}
                                    </AppSpan>
                                </CustomContainer>
                            )
                        })
                    }
                </CustomContainer>
                { selectedBillingType === 'General' ?
                    <CustomContainer
                        width='74.5' minHeight='43' padding='2'
                        radius='0.8' borderColor='#EAECF0'
                    >
                        <AppText textSize='1.5' color='#667085'>
                            Easily customise your billing settings.
                        </AppText>
                        <Form topMargin="2" onSubmit={handleSubmit}>
                            <FlexRow 
                                justifyContent="space-between" 
                                gap="1.5" wrap="wrap"
                            >
                                <AppSpan color="#344054" fontWeight='500'>Flat fee</AppSpan>
                                <FormGroup 
                                    style={{width: '30rem'}}
                                    bottomMargin="0"
                                >
                                    <input 
                                        placeholder="Enter fee here" 
                                        name='monthlyFee'
                                        type='number'
                                        value={input.monthlyFee}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                            </FlexRow>
                            <FlexRow 
                                justifyContent="space-between" 
                                gap="1.5" wrap="wrap"
                                topMargin="2"
                            >
                                <AppSpan color="#344054" fontWeight='500'>Active users fee (per user)</AppSpan>
                                <FormGroup 
                                    style={{width: '30rem'}}
                                    bottomMargin="0"
                                >
                                    <input 
                                        placeholder="Enter fee here" 
                                        name='activeUsersFee'
                                        type='number'
                                        value={input.activeUsersFee}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                            </FlexRow>
                            <FlexRow 
                                justifyContent="space-between" 
                                gap="1.5" wrap="wrap"
                                topMargin="2"
                            >
                                <AppSpan color="#344054" fontWeight='500'>Total users fee (per user)</AppSpan>
                                <FormGroup 
                                    style={{width: '30rem'}}
                                    bottomMargin="0"
                                >
                                    <input 
                                        placeholder="Enter fee here" 
                                        name='totalUsersFee'
                                        type='number'
                                        value={input.totalUsersFee}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                            </FlexRow>
                            <FlexRow 
                                justifyContent="space-between" 
                                gap="1.5" wrap="wrap"
                                topMargin="2"
                            >
                                <AppSpan color="#344054" fontWeight='500'>Active backend users fee (per user)</AppSpan>
                                <FormGroup 
                                    style={{width: '30rem'}}
                                    bottomMargin="0"
                                >
                                    <input 
                                        placeholder="Enter fee here" 
                                        name='activeBackendUsersFee'
                                        type='number'
                                        value={input.activeBackendUsersFee}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                            </FlexRow>
                            <FlexRow 
                                justifyContent="space-between" 
                                gap="1.5" wrap="wrap"
                                topMargin="2"
                            >
                                <AppSpan color="#344054" fontWeight='500'>Total backend users fee (per user)</AppSpan>
                                <FormGroup 
                                    style={{width: '30rem'}}
                                    bottomMargin="0"
                                >
                                    <input 
                                        placeholder="Enter fee here" 
                                        name='totalBackendUsersFee'
                                        type='number'
                                        value={input.totalBackendUsersFee}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </FormGroup>
                            </FlexRow>

                            <FlexRow justifyContent="flex-end" topMargin='2'>
                                <Button
                                    width='6.7'
                                    fontWeight="500" 
                                    height='4' radius='0.8'
                                    hoverColor='#0D968F'
                                    hoverBgColor='#ffffff' borderColor='#0D968F'
                                >
                                    Save
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                    :
                    <CustomContainer>
                        <FlexRow 
                            justifyContent='space-between'
                            bottomMargin='1.5' gap='2'
                            wrap='wrap'
                        >
                            <AppText textSize='1.5' color='#667085' fontWeight="400">
                                Institution specific monthly billing
                            </AppText>
                            <Button
                                width='28.2' fontWeight="500"
                                height='4' radius='0.8' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                                onClick={handleCreateInstitutionBillingConfig}
                            >
                                Create New Institution Configuration
                            </Button>
                        </FlexRow>
                        <ServerSideTable
                            tableData={institutionBillingConfigs}
                            tableColumns={billingConfigurationsColumns(handleBillingConfigAction)} 
                            dataFetchMethod={handleFetchProductBillingConfig}
                            totalRows={institutionBillingConfigsInfo?.totalRecords}
                            customStyle
                        />
                    </CustomContainer>
                }
            </FlexRow>
            { ['create-config', 'edit-config'].includes(view) &&
                <CreateInstitutionBillingConfig 
                    product={product}
                    config={selectedBillingConfig}
                    getUpdatedConfigs={handleFetchInstitutionBillingConfigs}
                    close={() => setView('')}
                />
            }
        </>
    )
}